@import "../../../constants.scss";

.input-wrap-text-area {
  &.auto-size-textarea {
    .input-holder {
      min-height: 38px;
      height: auto;
      max-width: 100%;
      overflow: hidden;
      margin: 0;

      textarea {
        white-space: pre-wrap;
        padding: 8px var(--input-padding) 7px var(--input-padding);
        resize: none;
        border: none;
        outline: none;
        margin: 0;
      }
    }
  }
  &.is-disabled {
    pointer-events: none;
  }
  &.has-copy {
    &.is-disabled {
      pointer-events: auto;
    }
  }
}

.char-counter {
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-1) var(--input-padding) 0;
  @include caption-typography;
  color: var(--input-color);
}

.preview-holder {
  background-color: var(--input-background-color);
  border-radius: 2px;
  padding: 8px var(--input-padding) 7px var(--input-padding);
  width: 100%;
  height: 100%;
}
